import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormROValue from '../../../../library/form/components/FormROValue1'
import SarasPopup from '../../../../library/container/popup/SarasPopup';
import FormWrapper from '../../../../library/form/components/FormWrapper';

const TaskMini = (props) => {
    const { formObject, anchorRef } = props;
    return (
        <SarasPopup anchorRef={anchorRef} open={true}>
            <div className="uiDashPop" >
                <div>
                    <ul className="uiFormMini">
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskId" }} value="ID" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "taskId" }} className="uiVal" />

                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "priority" }} className="uiVal" />

                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "createdBy" }} value="Created By" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "createdBy" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskDate" }} value="Date" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "taskDate" }} className="uiVal" />
                        </li>
                        <li>
                        <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "status" }} value="Status" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "status" }} className="uiVal" />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "taskStatusBy" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "profile" }} className="uiVal" />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "requestedBy" }} className="uiVal" />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profile2" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile2" }} value="" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "profile2" }} className="uiVal" />
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "area" }} value="Task Area" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "area" }} className="uiVal" />

                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "type1" }} value="Type 1" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "type1" }} className="uiVal" />

                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "type2" }} value="Type 2" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "type2" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskDesc" }} value="Description" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "taskDesc" }} className="uiVal uiHighlightMsg" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "preReq" }} value="Pre Requisite" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "preReq" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "allocatedTo" }} value="Allocated To" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "allocatedTo" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "address" }} value="Address" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "address" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "visitDate" }} value="Visit Date" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "visitDate" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "recentLog" }} value="Recent Log" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "recentLog" }} className="uiVal" />
                        </li>
                    </ul>
                </div>
            </div>
        </SarasPopup>
    )
}

export default withView(TaskMini, "", "")